import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-135" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-136" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-[#1F9D6B] sm:h-44 sm:w-44" role="img" aria-label="Garanzia di soddisfazione di 7 giorni" data-id="element-137" data-mp="222wjc7wug0nm">
          <defs data-id="element-138" data-mp="19dz8uqyvj85f">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-139" data-mp="19fipiiofzl7q" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-140" data-mp="14dl1lb53k28g" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-141" data-mp="1j5vb8e7ztkfg" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-142" data-mp="1ecj0n805fe5p">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-143" data-mp="lpg2igzdx5fz">
              SODDISFATTI O RIMBORSATI · ACQUISTA SERENO ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-144" data-mp="tymiwb3d3t0a">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-145" data-mp="ypusb74ozedg">
            GIORNI
          </text>
        </svg>

        <div data-id="element-146" data-mp="62qjss6e4hwx">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-[#1E2B58] sm:text-5xl" data-id="element-147" data-mp="6306o6w528ye">
            Garanzia di soddisfazione di 7 giorni
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-[#1E2B58]/75" data-id="element-148" data-mp="ezsjcoytn7s8">
            Scarica il materiale e prova come funziona nella tua classe. Se il pacchetto
            non soddisfa le tue aspettative, puoi contattarci via e-mail e chiedere il rimborso entro
            7 giorni dall'acquisto, secondo le condizioni di garanzia.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-[#1E2B58]/60" data-id="element-149" data-mp="3ri72xo4y7ro8">
            La garanzia non limita i tuoi diritti previsti dal Codice del Consumo.
          </p>
        </div>
      </div>
    </section>;
}